module.exports = __webpack_public_path__ + "static/media/material-calendar.caa267cb.svg";